__turbopack_context__.v({
  "banner": "FirstPurchaseBanner-module__OgBKtq__banner",
  "countdown": "FirstPurchaseBanner-module__OgBKtq__countdown",
  "countdownBox": "FirstPurchaseBanner-module__OgBKtq__countdownBox",
  "countdownDisplay": "FirstPurchaseBanner-module__OgBKtq__countdownDisplay",
  "countdownLabel": "FirstPurchaseBanner-module__OgBKtq__countdownLabel",
  "countdownNumber": "FirstPurchaseBanner-module__OgBKtq__countdownNumber",
  "countdownTitle": "FirstPurchaseBanner-module__OgBKtq__countdownTitle",
  "promoInfo": "FirstPurchaseBanner-module__OgBKtq__promoInfo",
});
